import Stack from "@mui/material/Stack";

import { Resident } from "@graphql/api";

import PersonalDetails from "./PersonalDetails";
import InsuranceAdoptionDetails from "./InsuranceAdoptionDetails";
import PermanentExclusionDetails from "./PermanentExclusionDetails";
import ContactDetails from "./ContactDetails";
import CommunityDetails from "./CommunityDetails";
import MoveDatesDetails from "./MoveDatesDetails";
import LeaseDetails from "./LeaseDetails";
import ResidentDatesDetails from "./ResidentDatesDetails";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

export default function ResidentDetailsTabContent({
  isLoading,
  resident,
}: Props) {
  return (
    <Stack direction="column" spacing={2} width="100%">
      <PersonalDetails isLoading={isLoading} resident={resident} />
      <InsuranceAdoptionDetails isLoading={isLoading} resident={resident} />
      <PermanentExclusionDetails isLoading={isLoading} resident={resident} />
      <CommunityDetails isLoading={isLoading} resident={resident} />
      <MoveDatesDetails isLoading={isLoading} resident={resident} />
      <ContactDetails isLoading={isLoading} resident={resident} />
      <LeaseDetails isLoading={isLoading} resident={resident} />
      <ResidentDatesDetails isLoading={isLoading} resident={resident} />
    </Stack>
  );
}
